export default function getDataUrlFromFile(file) {
  return new Promise(ful => {
    const reader = new FileReader();

    reader.onload = function (e) {
      ful(e.target.result);
    };

    reader.readAsDataURL(file);
  });
}
